import React from "react";

const adress = () => {
  return (
    <div className=" col-md-4 col-sm-4 col-xs-12 contact-icons">
      <div className="footer_grid_left">
        <h5>Address Kos</h5>
        <p>
          Jl. Nangka, Bontomarannu<span> Gowa, Sulawesi-Selatan</span>
        </p>
      </div>
      <div className="footer_grid_left">
        <h5> Contact</h5>
        <p>
          +62 823 4646 2435 
        </p>
      </div>
      <div className="footer_grid_left">
        <h5>Email</h5>
        <p>
          <a href="solahuddin.hafid.tomaballo@gmail.com">solahuddin.hafid.tomaballo@gmail.com</a>
        </p>
      </div>
    </div>
  );
};

export default adress;
